import { Division, DivisionsTree } from '@gettactic/api';
import { useQuery } from '@tanstack/react-query';
import { useTacticHooks } from '../providers/TacticHooksProvider';

function byOfficeIdBuilder(divisionsTree: DivisionsTree | DivisionsTree[]) {
  const map = new Map<string, Division>();
  const visitNode = (node: DivisionsTree) => {
    if ('offices' in node) {
      for (const office of node.offices) {
        map.set(office.id, node);
      }
    }
    if ('children' in node) {
      for (const child of node.children) {
        visitNode(child);
      }
    }
  };

  if (Array.isArray(divisionsTree)) {
    for (const node of divisionsTree) {
      visitNode(node);
    }
  } else {
    visitNode(divisionsTree);
  }

  return map;
}

export interface UseDivisionsMenuQueryOptions {
  getFloors?: boolean;
}

export const useDivisionsMenuQuery = (
  options?: UseDivisionsMenuQueryOptions
) => {
  const { apiClient } = useTacticHooks();

  return useQuery({
    queryKey: ['useDivisionsMenuQuery', apiClient.slug, options?.getFloors],

    queryFn: async () => {
      const res = await apiClient.divisions.withOffices(
        undefined,
        options?.getFloors
      );
      const result = res.result;
      return result
        ? {
            tree: result,
            byOfficeId: byOfficeIdBuilder(result)
          }
        : undefined;
    },

    staleTime: 5000 * 60,
    enabled: !!apiClient.slug
  });
};
